import React from "react";
import { CombinatorSelectorProps } from "react-querybuilder";

export default function CombinatorSelector({ options, value, handleOnChange }: CombinatorSelectorProps) {
    return (
        <div className="qf-combinator">
            <select
                className="qf-combinator__select"
                value={value}
                onChange={(event) => handleOnChange(event.target.value)}
            >
                {options.map((option: any) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
}
